import { ICurriculumMap, ITableRes, IUnit, IUnitData, IUnitItem, IUnitParams } from 'types'
import { baseApi } from './baseApi'
import { MAX_PER_PAGE } from 'utils/constants'

export const unitsAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    GET_curriculumMap: builder.query<ICurriculumMap, any>({
        query: (params) => ({
          url: `/curriculum-map/subject/${params.subject_id}/grade/${params.grade_level}/`,
        }),
        providesTags: ['curriculum-map'],
      }),
    GET_units: builder.query<ITableRes<IUnitItem>, IUnitParams>({
      query: (params) => ({
        url: '/course-units/',
        params,
      }),
      providesTags: ['units'],
    }),
    GET_unitsSelect: builder.query<ITableRes<IUnitItem>, IUnitParams>({
      query: (params) => ({
        url: '/course-units/',
        params: {...params, page_size: MAX_PER_PAGE},
      }),
      transformResponse: (response: ITableRes<IUnit>): any => {
        const hasMore = Boolean(response?.next)
        const count = response?.count || 0
        return {
          list: response?.results || [],
          count,
          hasMore,
        }
      },
      providesTags: ['units'],
    }),
    GET_unitById: builder.query<IUnit, string>({
      query: (id) => {
        return {
          url: `/course-units/${id}/`,
        }
      },
      providesTags: ['units'],
    }),
    POST_unit: builder.mutation<IUnit, IUnitData>({
      query: (body) => ({
        url: `/course-units/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['units', 'curriculum-map'],
    }),
    PATCH_unit: builder.mutation<IUnit, { id: string; body: IUnitData }>({
      query: ({ id, body }) => ({
        url: `/course-units/${id}/`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['units', 'curriculum-map'],
    }),
    DELETE_unit: builder.mutation<IUnit, string>({
      query: (id) => ({
        url: `/course-units/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['units', 'curriculum-map'],
    }),
    POST_addUnitMaterial: builder.mutation<any, { id: string; formData: any }>({
      query: ({ id, formData }) => ({
        url: `/assignments/${id}/add_materials/`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['units', 'curriculum-map'],
    }),
    DELETE_removeUnitMaterial: builder.mutation<any, { id: string; attachmentId: string }>({
      query: ({ id, attachmentId }) => ({
        url: `/assignments/${id}/materials/${attachmentId}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['units', 'curriculum-map'],
    }),
  }),
})

export const { 
  useGET_curriculumMapQuery, 
  useGET_unitsQuery, 
  useGET_unitsSelectQuery, 
  useGET_unitByIdQuery, 
  usePOST_unitMutation, 
  usePATCH_unitMutation, 
  useDELETE_unitMutation, 
  usePOST_addUnitMaterialMutation,
  useDELETE_removeUnitMaterialMutation
} = unitsAPI
